'use client';

import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { Fragment, useMemo } from 'react';
import { AttributeSideDynamic } from './attributes/attribute';

export function ProgressiveCategoryAttributes({
  attributes,
  className,
  initialCount = 10,
  separatorClassName,
}: {
  attributes: AttributesEntity[];
  className?: string;
  initialCount?: number;
  separatorClassName?: string;
}) {
  const selectedAttributes = useCategoryStore(state => state.filter.attributes);
  const selectedIds = useMemo(
    () => new Set(selectedAttributes.map(attribute => attribute.id)),
    [selectedAttributes],
  );

  const orderedAttributes = useMemo(
    () =>
      attributes
        .map((attribute, index) => ({ attribute, index }))
        .sort((left, right) => {
          const leftSelected = selectedIds.has(left.attribute.id) ? 1 : 0;
          const rightSelected = selectedIds.has(right.attribute.id) ? 1 : 0;
          return rightSelected - leftSelected || left.index - right.index;
        })
        .map(item => item.attribute),
    [attributes, selectedIds],
  );
  const effectiveVisibleCount = Math.max(initialCount, selectedIds.size);
  const visibleAttributes = orderedAttributes.slice(0, effectiveVisibleCount);

  return (
    <>
      {visibleAttributes.map(attribute => (
        <Fragment key={`attribute-${attribute.id ?? attribute.name}`}>
          <AttributeSideDynamic
            name={attribute.name}
            attribute={attribute}
            className={{ wrapper: className }}
          />
          <Separator className={separatorClassName} />
        </Fragment>
      ))}
    </>
  );
}
